import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printable-header',
  templateUrl: './printable-header.component.html',
  styleUrls: [ './printable-header.component.scss' ]
})
export class PrintableHeaderComponent implements OnInit {
  public logoImage: string;

  constructor() {
  }

  async ngOnInit(): Promise<void> {
    this.logoImage = await this.getBase64ImageFromURL('/assets/images/logo/logo-text_black.svg');
  }

  getBase64ImageFromURL(url): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');

      img.onload = (): void => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL('image/png');

        resolve(dataURL);
      };

      img.onerror = (error): void => {
        reject(error);
      };

      img.src = url;
    });
  }

}
